import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/languages',
    name: 'languages',
    props: true,
    meta: {
      title: 'Languages'
    },
    component: () => import('@/views/product-options/items/LanguageListView.vue')
  },
  {
    path: '/languages/create',
    name: 'language-create',
    meta: {
      title: 'Create Language'
    },
    component: () => import('@/views/product-options/items/LanguageCreateView.vue')
  },
  {
    path: '/languages/:id',
    name: 'language-edit',
    props: true,
    meta: {
      title: 'Edit Language'
    },
    component: () => import('@/views/product-options/items/LanguageEditView.vue'),
    children: [
      {
        path: '/languages/:id/f/:section',
        name: 'language-edit-section',
        props: true,
        meta: {
          title: 'Edit Language'
        },
        component: () => import('@/views/product-options/items/LanguageEditView.vue')
      }
    ]
  },
  {
    path: '/items/deliveries',
    name: 'deliveries',
    meta: {
      title: 'Deliveries'
    },
    component: () => import('@/views/product-options/items/DeliveryListView.vue')
  },
  {
    path: '/items/deliveries/create',
    name: 'delivery-create',
    props: true,
    meta: {
      title: 'Create Delivery'
    },
    component: () => import('@/views/product-options/items/DeliveryCreateView.vue')
  },
  {
    path: '/items/deliveries/:id',
    name: 'delivery-edit',
    props: true,
    meta: {
      title: 'Edit Delivery'
    },
    component: () => import('@/views/product-options/items/DeliveryEditView.vue'),
    children: [
      {
        path: '/items/deliveries/:id/f/:section',
        name: 'delivery-edit-section',
        props: true,
        meta: {
          title: 'Edit Delivery'
        },
        component: () => import('@/views/product-options/items/DeliveryEditView.vue')
      }
    ]
  },
  {
    path: '/items/translations',
    name: 'translations',
    meta: {
      title: 'Translations'
    },
    component: () => import('@/views/product-options/items/TranslationListView.vue')
  },
  {
    path: '/items/translations/create',
    name: 'translation-create',
    props: true,
    meta: {
      title: 'Create Translation'
    },
    component: () => import('@/views/product-options/items/TranslationCreateView.vue')
  },
  {
    path: '/items/translations/:id',
    name: 'translation-edit',
    props: true,
    meta: {
      title: 'Edit Translation'
    },
    component: () => import('@/views/product-options/items/TranslationEditView.vue'),
    children: [
      {
        path: '/items/translations/:id/f/:section',
        name: 'translation-edit-section',
        props: true,
        meta: {
          title: 'Edit Translation'
        },
        component: () => import('@/views/product-options/items/TranslationEditView.vue')
      }
    ]
  },
  {
    path: '/countries',
    name: 'countries',
    meta: {
      title: 'Countries'
    },
    component: () => import('@/views/product-options/items/CountryListView.vue')
  },
  {
    path: '/countries/create',
    name: 'country-create',
    meta: {
      title: 'Create Country'
    },
    component: () => import('@/views/product-options/items/CountryCreateView.vue')
  },
  {
    path: '/countries/:id',
    name: 'country-edit',
    props: true,
    meta: {
      title: 'Edit Country'
    },
    component: () => import('@/views/product-options/items/CountryEditView.vue'),
    children: [
      {
        path: '/countries/:id/f/:section',
        name: 'country-edit-section',
        props: true,
        meta: {
          title: 'Edit Country'
        },
        component: () => import('@/views/product-options/items/CountryEditView.vue')
      }
    ]
  },
  {
    path: '/federal-states',
    name: 'federal-states',
    meta: {
      title: 'Federal States'
    },
    component: () => import('@/views/product-options/items/FederalStateListView.vue')
  },
  {
    path: '/federal-states/create',
    name: 'federal-state-create',
    meta: {
      title: 'Create Federal State'
    },
    component: () => import('@/views/product-options/items/FederalStateCreateView.vue')
  },
  {
    path: '/federal-states/:id',
    name: 'federal-state-edit',
    props: true,
    meta: {
      title: 'Edit Federal State'
    },
    component: () => import('@/views/product-options/items/FederalStateEditView.vue'),
    children: [
      {
        path: '/federal-states/:id/f/:section',
        name: 'federal-state-edit-section',
        props: true,
        meta: {
          title: 'Edit Federal State'
        },
        component: () => import('@/views/product-options/items/FederalStateEditView.vue')
      }
    ]
  }
]

export default routes
